<template lang="pug">
fieldset(:disabled="loading")
  form(@submit.prevent="update")
    modal(active, title="Editar OS-m", @close="$emit('close')")
      div(slot="modal-body")
        .columns
          form-group.column.col-12(
            :label="'ordem_servico.usuario_responsavel' | tModel",
            :validation="$v.form.usuario_responsavel_id"
          )
            fiscal-picker(v-model="$v.form.usuario_responsavel_id.$model")
          form-group.column.col-12(
            :label="'ordem_servico.analista' | tModel",
            :validation="$v.form.analista_id"
          )
            fiscal-picker(v-model="$v.form.analista_id.$model")
          form-group.column.col-12(
            :label="'ordem_servico.situacao' | tModel",
            :validation="$v.form.situacao"
          )
            select-ordem-servico-situacao(
              v-model="$v.form.situacao.$model",
              :situacoes="allowedSituacoes"
            )
          form-group.column.col-3.col-sm-12(
            :label="'ordem_servico.protocolo_tipo' | tModel",
            :validation="$v.form.protocolo_tipo"
          )
            select-protocolo-tipo(v-model="$v.form.protocolo_tipo.$model")
          form-group.column.col-3.col-sm-12(
            v-if="form.protocolo_tipo === 'sei'",
            :label="'ordem_servico.protocolo_numero' | tModel",
            :validation="$v.form.protocolo_numero"
          )
            the-mask.form-input(
              v-model="$v.form.protocolo_numero.$model",
              type="tel",
              mask="##.##.########/####-##",
              :masked="true"
            )
          form-group.column.col-3.col-sm-12(
            v-else,
            :label="'ordem_servico.protocolo_numero' | tModel",
            :validation="$v.form.protocolo_numero"
          )
            input.form-input(v-model="$v.form.protocolo_numero.$model")
          form-group.column.col-3.col-sm-12(
            :disabled="form.protocolo_tipo === 'sei'",
            :label="'ordem_servico.protocolo_ano' | tModel",
            :validation="$v.form.protocolo_ano"
          )
            year.form-input(v-model="$v.form.protocolo_ano.$model")
          form-group.column.col-3.col-sm-12(
            :label="'ordem_servico.protocolo_data' | tModel",
            :validation="$v.form.protocolo_data"
          )
            datepicker(v-model="$v.form.protocolo_data.$model")
          form-group.column.col-3.col-sm-12(
            :label="'ordem_servico.prazo' | tModel",
            :validation="$v.form.prazo"
          )
            int.form-input(v-model="$v.form.prazo.$model")
          form-group.column.col-12(:validation="$v.form.agendar")
            label.form-switch
              input(type="checkbox", v-model="$v.form.agendar.$model")
              i.form-icon
              | É necessário agendar
          .column.col-12.divider.text-center
          form-group.column.col-12(
            :label="'ordem_servico_info.obs' | tModel",
            :validation="$v.form.info.obs"
          )
            textarea.form-input(v-model="$v.form.info.obs.$model", rows="4")
      .text-right(slot="modal-footer")
        button.btn.btn-primary(:disabled="$v.form.$invalid") Salvar
</template>

<script>
import { deepClone, sanitize } from "paliari-js-utils"
import { required, maxLength } from "vuelidate/lib/validators"
import toastErrors from "@/lib/errors/toastErrors"

export default {
  vuex: {
    servicos: {
      actions: ["fetchUpdate"],
      getters: ["loading"],
      state: ["current", "status"],
    },
  },
  data() {
    return {
      form: {},
      allowedSituacoes: {
        andamento: "Em andamento",
        aguardando_distribuir: "Aguardando Distribuir",
        abertura: "Em Abertura",
        reaberto: "Reaberto",
        reabrindo: "Reabrindo",
        cancelada: "Cancelada",
        encerrada: "Encerrada",
        em_distribuicao: "Em distribuição",
      },
    }
  },
  computed: {
    protocoloTipos() {
      return this.$i18n.t("enums.db.enum_protocolo_tipo")
    },
  },
  validations: {
    form: {
      usuario_responsavel_id: {},
      analista_id: {},
      protocolo_tipo: { required },
      protocolo_numero: {},
      protocolo_ano: {},
      agendar: {},
      protocolo_data: {},
      info: { obs: { maxLength: maxLength(4000) } },
      situacao: {},
      prazo: {},
    },
  },
  methods: {
    update() {
      this.fetchUpdate(this.form)
        .then(() => {
          this.$toaster.success("Alterado com sucesso")
          this.$emit("close")
        })
        .catch((e) => toastErrors(e))
    },
  },
  created() {
    const rules = {
      id: true,
      usuario_responsavel_id: true,
      analista_id: true,
      protocolo_tipo: true,
      protocolo_numero: true,
      protocolo_ano: true,
      agendar: true,
      protocolo_data: true,
      info: { obs: true },
      situacao: true,
      prazo: true,
    }
    this.form = sanitize(deepClone(this.current), rules)
  },
}
</script>
